



import React, {useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import {Minus,Activity ,ChevronLeft,X,Plus ,Phone,Check,Video,MonitorPlay,BookOpenCheck,
  TabletSmartphone,NotebookPen,BookDown,NotepadText,BookA,GalleryHorizontal,BadgePlus} from 'lucide-react';


const WhatsIncludedInACourse=({index ,iconColor,textColor,contentType,no,id,totalNumber,status,contentIcon,editable,onRemove,changetotalNumber,changeItemStatus,changeItemTitle})=>{
  const dispatch = useDispatch();  
  const handleMouseEnter = () =>dispatch({
    type: "CURSOR",
    
    payload:true
  });
  const handleMouseLeave = () => dispatch({
    type: "CURSOR",
    
    payload:false
  });
  const [totalNo, setTotalNo] = useState(totalNumber);
    const [areYouSure, setAreYouSure] = useState(false);
    const [isSelected, setIsSelected] = useState(status); 
    const [itemTitle, setItemTitle] = useState(contentType); 
    const RenderIcon = ({ componentString }) => {
      // Check the componentString to decide which icon to render
      if (componentString === 'BookOpenCheck') {
        return <BookOpenCheck size={20} color={iconColor} strokeWidth={3} />;
      } if (componentString === 'Video') {
        return <Video size={20} color={iconColor} strokeWidth={3} />;
      }if (componentString === 'MonitorPlay') {
        return <MonitorPlay size={20} color={iconColor} strokeWidth={3} />;
      }if (componentString === 'NotepadText') {
        return <NotepadText size={20} color={iconColor} strokeWidth={3} />;
      }if (componentString === 'TabletSmartphone') {
        return <TabletSmartphone size={20} color={iconColor} strokeWidth={3} />;
      }if (componentString === 'BookDown') {
        return <BookDown size={20} color={iconColor} strokeWidth={3} />;
      }if (componentString === 'GalleryHorizontal') {
        return <GalleryHorizontal size={20} color={iconColor} strokeWidth={3} />;
      }if (componentString === 'BookA') {
        return <BookA size={20} color={iconColor} strokeWidth={3} />;
      }if (componentString === 'BookOpenCheck') {
        return <BookOpenCheck size={20} color={iconColor} strokeWidth={3} />;
      }if (componentString === 'BadgePlus') {
        return <BadgePlus size={20} color={iconColor} strokeWidth={3} />;
      }
      // Add more cases if needed for other icons
    
      return null;
    };
     useEffect(()=>{
      setIsSelected(status)
     },[])
   return(
    status?<div className=" coursePageSubTitleFont" style={{margin:"10px",fontSize:"14px",fontWeight:"bold",color:textColor,display:"flex",justifyContent:"left",gap:"10px"}}>
   <RenderIcon componentString={contentIcon} /> {totalNumber}   {contentType}  
</div>:""
    )
}  

export default WhatsIncludedInACourse;
